// src/components/ProfilePicker.jsx
import React from "react";
import { signOut } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { auth } from "../firebase";
import { SCHOOL } from "../config";

export default function ProfilePicker({ students, onPick }) {
  const navigate = useNavigate();

  async function logout() {
    await signOut(auth);
    navigate("/login");
  }

  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center",
                  justifyContent: "center", background: "#FBF0E8", padding: "24px" }}>
      <div style={{ background: "white", borderRadius: "20px",
                    padding: "40px 36px", maxWidth: "460px", width: "100%",
                    boxShadow: "0 4px 24px rgba(123,21,21,.12)" }}>

        <div style={{ textAlign: "center", marginBottom: "28px" }}>
          <picture>
            <source srcSet="/logo.webp" type="image/webp" />
            <img src="/logo.png" alt={SCHOOL.name}
              style={{ width: "56px", height: "56px", objectFit: "contain",
                       borderRadius: "10px", marginBottom: "14px" }}/>
          </picture>
          <h2 style={{ fontSize: "1.3rem", fontWeight: "800",
                       color: "#1F2937", marginBottom: "6px" }}>
            Who's studying today?
          </h2>
          <p style={{ color: "#6B7280", fontSize: ".88rem" }}>
            Select a student to continue
          </p>
        </div>

        <div style={{ display: "flex", flexDirection: "column",
                      gap: "12px", marginBottom: "28px" }}>
          {students.map(student => (
            <button key={student.id} onClick={() => onPick(student.id)}
              style={{ display: "flex", alignItems: "center", gap: "16px",
                       padding: "14px 18px", borderRadius: "14px",
                       border: "2px solid #F5E4D0", background: "#FBF0E8",
                       cursor: "pointer", textAlign: "left", width: "100%",
                       transition: "border-color .15s, box-shadow .15s" }}
              onMouseEnter={e => {
                e.currentTarget.style.borderColor = "#7B1515";
                e.currentTarget.style.boxShadow = "0 4px 12px rgba(123,21,21,.15)";
              }}
              onMouseLeave={e => {
                e.currentTarget.style.borderColor = "#F5E4D0";
                e.currentTarget.style.boxShadow = "none";
              }}>
              <div style={{ width: "52px", height: "52px", borderRadius: "50%",
                            background: "#7B1515", border: "3px solid #F5E4D0",
                            display: "flex", alignItems: "center", justifyContent: "center",
                            overflow: "hidden", flexShrink: 0 }}>
                {student.photoUrl
                  ? <img src={student.photoUrl} alt=""
                      style={{ width: "100%", height: "100%", objectFit: "cover" }}/>
                  : <span style={{ fontSize: "1.4rem", color: "white" }}>👤</span>}
              </div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontWeight: "700", fontSize: "1rem", color: "#1F2937" }}>
                  {student.name}
                </div>
                {(student.subject || student.abgmmLevel) && (
                  <div style={{ fontSize: ".82rem", color: "var(--purple-text)", marginTop: "2px" }}>
                    {[student.subject, student.abgmmLevel].filter(Boolean).join(" · ")}
                  </div>
                )}
              </div>
              <span style={{ color: "var(--purple-text)", fontSize: "1.3rem", flexShrink: 0 }}>›</span>
            </button>
          ))}
        </div>

        <button onClick={logout}
          style={{ width: "100%", background: "none", border: "none",
                   color: "#9CA3AF", cursor: "pointer",
                   fontSize: ".85rem", padding: "8px" }}>
          Sign out
        </button>

      </div>
    </div>
  );
}
